/**
 * Auth0-compatible user object
 */
export interface UserForAppBar {
  email?: string;
  given_name?: string;
  family_name?: string;
  name?: string;
}

/**
 * TODO Move to @marex/auth-js
 *
 * Not to be exported from @mds/app-layout
 */
export function getUserInitials(user: UserForAppBar): string | undefined {
  const { given_name, family_name, name } = user;

  if (given_name && family_name) {
    return `${given_name.charAt(0)}${family_name.charAt(0)}`.toUpperCase();
  }

  if (name) {
    const nameParts = name.split(' ');
    if (nameParts.length >= 2) {
      return `${nameParts[0]!.charAt(0)}${nameParts[nameParts.length - 1]!.charAt(0)}`.toUpperCase();
    }
    return nameParts[0]!.charAt(0).toUpperCase();
  }
}

/**
 * TODO Move to @marex/auth-js
 *
 * Not to be exported from @mds/app-layout
 */
export function getDisplayName(user: UserForAppBar): string | undefined {
  const { given_name, family_name, name, email } = user;
  return [given_name, family_name].filter(Boolean).join(' ') || name || email;
}
